<template>
  <v-layout>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <input-form :title="title" :deletable="deletable" :refreshable="refreshable" :editable="contentEditable?true:editable" :approval="approval"
                      @close="close" @save="save" @delete="_delete" @refresh="refresh" @input="change">
            <v-container grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 lg4>
                  <v-text-field label="Batch No." :value="request.batchNo" readonly disabled @input="change" />
                </v-flex>
                <v-flex xs12 lg4>
                  <v-layout row wrap class="ma-0">
                  <v-select :items="docStates" :value="request.documentState" label="Document State"
                            v-if="docStatesLoaded && typeof (docStates.find(x => x === request.documentState)) !== 'undefined'"
                            return-object :disabled="contentEditable?false:!editable || submitted" :readonly="contentEditable?false:!editable || submitted"
                            @input="(value) => changeProperty('documentState', value)" required />
                  <v-text-field :value="request.documentState" label="Document State"
                                readonly disabled @input="change" required v-else />
                  <v-icon v-if="contentEditable ||
                    (docStatesLoaded && typeof (docStates.find(x => x === request.documentState)) !== 'undefined')"
                    :color="docStatebackup?'error':'success'" class="mx-3 pointer" @click="editDocState">{{docStatebackup?'cancel':'edit'}}
                  </v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 lg4>
                  <date-time-picker :value="request.requestDate" label="Request Date" :readonly="!editable"
                                    :disabled="!editable" :rules="rules.requestDate" date-only
                                    @input="(value) => changeProperty('requestDate', value)" required />
                </v-flex>
                <v-flex xs12 lg4>
                  <v-select :value="request.hcOrganization" label="HC Organization" :items="organizations" autocomplete
                            :readonly="!editable" :disabled="!editable" item-value="id" item-text="name"
                            return-object :rules="rules.hcOrganization" required
                            v-if="organizationsLoaded" @input="(value) => changeProperty('hcOrganization', value)" />
                </v-flex>
                <v-flex xs12 lg4>
                  <v-select :value="request.approvalType" label="Approval Type" v-if="approvalTypesLoaded" autocomplete
                            :readonly="!editable" :disabled="!editable" return-object required
                            :items="approvalTypes[request.hcOrganization.id]" item-value="id" item-text="typeName"
                            :rules="rules.approvalType" @input="(value) => changeProperty('approvalType', value)" />
                </v-flex>
                <v-flex xs12 lg4>
                  <v-select :value="request.extApproval" label="Ext. Approval" v-if="extTypesLoaded" autocomplete
                            :disabled="typeof extTypes[request.approvalType.id] === 'undefined' || extTypes[request.approvalType.id].length === 0 || !editable"
                            :readonly="!editable" return-object
                            :required="typeof extTypes[request.approvalType.id] !== 'undefined' && extTypes[request.approvalType.id].length > 0"
                            :items="extTypesWithNIK" item-value="empId" item-text="_display"
                            :rules="rules.extApproval" @input="(value) => changeProperty('extApproval', value)" />
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select :value="request.fromCity" label="From City" v-if="citiesLoaded" autocomplete
                            :readonly="!editable" :disabled="!editable" return-object required
                            :items="cities" item-value="id" item-text="value" :rules="rules.fromCity"
                            @input="(value) => changeProperty('fromCity', value)" />
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select :value="request.toCity" label="To City" v-if="citiesLoaded" autocomplete
                            :readonly="!editable" :disabled="!editable" return-object required
                            :items="cities" item-value="id" item-text="value" :rules="rules.toCity"
                            @input="(value) => changeProperty('toCity', value)" />
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select :value="request.impositionType" label="Imposition Type" v-if="impositionTypesLoaded"
                            :readonly="!editable" :disabled="!editable" required
                            autocomplete :items="impositionTypes" item-value="impositionType" item-text="impositionType"
                            :rules="rules.impositionType" @input="(value) => changeProperty('impositionType', value)" />
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select :value="request.imposition" label="Imposition" v-if="impositionsLoaded" autocomplete
                            :readonly="!editable" :disabled="!editable" return-object required
                            :items="impositions[request.impositionType.toLowerCase()]" item-value="id"
                            item-text="impositionName" :rules="rules.imposition" @input="(value) => changeProperty('imposition', value)" />
                </v-flex>
                <v-flex xs12>
                  <v-text-field multi-line rows="2" label="Remark" :value="request.remark"
                                :readonly="!editable" :disabled="!editable"
                                :rules="rules.remark" @input="(value) => changeProperty('remark', value)" />
                </v-flex>
              </v-layout>
            </v-container>
          </input-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Promise from 'promise-polyfill'
import InputForm from '@/components/InputForm'
import DateTimePicker from '@/components/lookup/DateTimePicker'

import Vuex from 'vuex'

const genericStore = Vuex.createNamespacedHelpers('Generic')
const orgStore = Vuex.createNamespacedHelpers('Organization')
const approvalTypeStore = Vuex.createNamespacedHelpers('ApprovalType')
const impositionStore = Vuex.createNamespacedHelpers('BusinessTripImposition')

export default {
  name: 'business-trip-request-form',
  components: {
    InputForm,
    DateTimePicker
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Business Trip Reques'
    },
    value: {
      type: Object,
      required: true
    },
    deletable: {
      type: Boolean,
      required: false,
      default: false
    },
    refreshable: {
      type: Boolean,
      required: false,
      default: false
    },
    contentEditable: {
      type: Boolean,
      required: false,
      default: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    approval: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      request: this.value,
      approvalTypesLoaded: false,
      extTypesLoaded: false,
      organizationsLoaded: false,
      citiesLoaded: false,
      impositionTypesLoaded: false,
      impositionsLoaded: false,
      docStatebackup: null,
      docStatesLoaded: false,
      submitted: this.value.documentState === 'SUBMITTED',
      rules: {
        requestDate: [
          v => new Date(v) instanceof Date || 'Date is required'
        ],
        hcOrganization: [
          v => !!v.id || 'Organization is required',
          v => (typeof this.organizations.find(x => x.id === v.id) !== 'undefined') || 'Unknown Organization'
        ],
        approvalType: [
          v => !!v || 'Approval type is required',
          v => (typeof this.approvalTypes[this.request.hcOrganization.id] !== 'undefined' &&
            typeof this.approvalTypes[this.request.hcOrganization.id].find(x => x.id === v.id) !== 'undefined') ||
            'Unknown approval type'
        ],
        extApproval: [
          v => typeof this.extTypes === 'undefined' ||
            typeof this.extTypes[this.request.approvalType.id] === 'undefined' ||
            this.extTypes[this.request.approvalType.id].length === 0 ||
            (!!v && typeof this.extTypes[this.request.approvalType.id].find(x => x.empId === v.empId) !== 'undefined') ||
            'Unknown ext approval'
        ],
        fromCity: [
          v => !!v || 'City is required',
          v => typeof this.cities.find(x => x.id === v.id) !== 'undefined' || 'Unknown city'
        ],
        toCity: [
          v => !!v || 'City is required',
          v => typeof this.cities.find(x => x.id === v.id) !== 'undefined' || 'Unknown city'
        ],
        impositionType: [
          v => !!v || 'Type is required',
          v => this.impositionTypes.map(x => x.impositionType).includes(v) || 'Unknown imposition type'
        ],
        imposition: [
          v => !!v || 'Imposition is required',
          v => typeof this.impositions[this.request.impositionType.toLowerCase()]
            .find(x => x.id === v.id) !== 'undefined' || 'Unknown imposition'
        ],
        remark: [
          v => v.length <= 500 || 'Max. 500 characters'
        ]
      }
    }
  },
  computed: {
    ...genericStore.mapState({
      cities: 'cities',
      docStates: 'docStates'
    }),
    ...approvalTypeStore.mapState({
      approvalTypes: 'orgs',
      extTypes: 'types'
    }),
    ...orgStore.mapState({
      organizations: 'authItems'
    }),
    ...impositionStore.mapState({
      impositionTypes: 'types',
      impositions: 'actives'
    }),
    extTypesWithNIK () {
      const extTypes = (this.extTypes[this.request.approvalType.id] || [])
        .map(x => { return {...x, _display: x.name + ' (' + x.nik + ')'} })
      return extTypes
    }
  },
  watch: {
    'request.hcOrganization' (newValue, oldValue) {
      const self = this
      // load approval type
      self.approvalTypesLoaded = false
      self.listApprovalTypes({vueinstance: self, orgid: newValue.id})
        .then(res => { self.approvalTypesLoaded = true }).catch(err => self.$error(err))
      if (typeof oldValue !== 'undefined') {
        self.request.approvalType = {}
        self.request.extApproval = null
      }
    },
    'request.approvalType' (newValue, oldValue) {
      const self = this
      // load ext approval
      if (newValue.id !== null) {
        self.extTypesLoaded = false
        self.listExtApproval({vueinstance: self, id: newValue.id})
          .then(res => { self.extTypesLoaded = true }).catch(err => self.$error(err))
      }

      if (typeof oldValue !== 'undefined') {
        self.request.extApproval = null
      }
    },
    'request.impositionType' (newValue, oldValue) {
      const self = this
      self.impositionsLoaded = false
      self.listImpositions({vueinstance: self, category: newValue})
        .then(res => { self.impositionsLoaded = true }).catch(err => self.$error(err))

      if (typeof oldValue !== 'undefined') {
        self.request.imposition = {}
      }
    }
  },
  methods: {
    ...genericStore.mapActions({
      listDocStates: 'listDocStates',
      listCities: 'listCities'
    }),
    ...orgStore.mapActions({
      listOrganizations: 'listAuthorized'
    }),
    ...approvalTypeStore.mapActions({
      listApprovalTypes: 'listByOrg',
      listExtApproval: 'listByTypeId'
    }),
    ...impositionStore.mapActions({
      listImpositionTypes: 'typeList',
      listImpositions: 'listActive'
    }),
    editDocState () {
      if (this.docStatebackup) {
        this.cancelDocState()
      } else {
        this.docStatebackup = this.request.documentState
        this.request.documentState = 'DRAFTED'
      }
    },
    cancelDocState () {
      this.request.documentState = this.docStatebackup
      this.docStatebackup = null
    },
    loadResources () {
      const self = this

      // load all required resources
      const promises = [self.listOrganizations({vueinstance: self}), self.listCities({vueinstance: self}),
        self.listImpositionTypes({vueinstance: self}), self.listDocStates({vueinstance: self})]
      Promise.all(promises)
        .then(res => {
          // load approval types, ext approval and impositions
          const morePromises = [self.listApprovalTypes({vueinstance: self, orgid: self.request.hcOrganization.id}),
            self.listExtApproval({vueinstance: self, id: self.request.approvalType.id}),
            self.listImpositions({vueinstance: self, category: self.request.impositionType})]
          Promise.all(morePromises)
            .then(res1 => {
              self.approvalTypesLoaded = true
              self.extTypesLoaded = true
              self.impositionsLoaded = true
            })
            .catch(err => self.$error(err))

          self.organizationsLoaded = true
          self.citiesLoaded = true
          self.impositionTypesLoaded = true
          self.docStatesLoaded = true
        })
        .catch(err => self.$error(err))
    },
    close () {
      this.$emit('close')
    },
    save () {
      // remove _display from extApproval if applicable
      if (this.request.extApproval !== null) {
        delete this.request.extApproval._display
      }
      this.$emit('save', this.request)
    },
    _delete () {
      this.$emit('delete', this.request)
    },
    change (value) {
      this.$emit('input', this.request)
    },
    changeProperty (property, value) {
      this.request[property] = value
      this.change(value)
    },
    refresh () {
      this.$emit('refresh')
    }
  },
  mounted () {
    this.loadResources()
  }
}
</script>

<style scoped>
.pointer{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestForm.vue